import React from 'react';

import StatusPill from './StatusPill';
import LessonDatesSection from './LessonDatesSection';
import LessonEditButton from './LessonEditButton';
import LessonPreviewButton from './LessonPreviewButton';
import Description from './Description.jsx';

const LessonMetadata = ({ lesson, setLesson }) => {
  return (
    <div className="px-32 pt-32 pb-32 d-f fd-c mb-10 DataCard">
      <div className="d-f jc-sb w-fill ai-fs">
        <StatusPill lesson={lesson} />
        <div className="d-f fd-r">
          <LessonEditButton lesson={lesson} />
          <LessonPreviewButton lesson={lesson} />
        </div>
      </div>
      <LessonDatesSection lesson={lesson} />
      <Description lesson={lesson} setLesson={setLesson} />
    </div>
  );
};
export default props => <LessonMetadata {...props} />;
